import Vue from "vue";

import VerifyIdentity from "./VerifyIdentity.vue";

export function load() {
    const selector = "verify-identity";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(VerifyIdentity, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}